import { render, staticRenderFns } from "./AvatarLightColor.vue?vue&type=template&id=13c0e0de&"
import script from "./AvatarLightColor.vue?vue&type=script&lang=js&"
export * from "./AvatarLightColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports